// Lab Phlebotomy Module
// Manages lab phlebotomy records and appointments

import LabPhlebotomyPage from "./pages/LabPhlebotomyPage";
import LabPhlebotomyCreatePage from "./pages/LabPhlebotomyCreatePage";

// Export routes for AppRouter
export const labPhlebotomyRoutes = [
  {
    path: "/LabPhlebotomy",
    element: <LabPhlebotomyPage />,
  },
  {
    path: "/LabPhlebotomy/create",
    element: <LabPhlebotomyCreatePage />,
  },
  {
    path: "/LabPhlebotomy/edit/:recordId",
    element: <LabPhlebotomyCreatePage />,
  },
];

// Export components for external use
export { default as LabPhlebotomyPage } from "./pages/LabPhlebotomyPage";
export { default as LabPhlebotomyCreatePage } from "./pages/LabPhlebotomyCreatePage";
export { default as LabPhlebotomyTable } from "./components/LabPhlebotomyTable";

// Export utilities
export {
  getLabPhlebotomyRecords,
  getLabPhlebotomyRecordById,
  createLabPhlebotomyRecord,
  updateLabPhlebotomyRecord,
  deleteLabPhlebotomyRecord,
  getCountsByMedicalCenter,
} from "./utils/labPhlebotomyStorage";
export * from "./constants/labPhlebotomyOptions";

// API Service functions (canonical source: specialist-referrals/services)
export {
  createLabPhlebotomy,
  updateLabPhlebotomy,
  deleteLabPhlebotomy,
  getLabPhlebotomyList,
  getLabPhlebotomyById,
  getPatientsWithActiveReferrals,
} from "../specialist-referrals/services/labPhlebotomyService";
